//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmInterniSubjektDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-15                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.3
//AdtGeneratorConfig:[ T:(ginsesu) GID:(Web.Set.Des.Ts) V1:(ixs_esu,aktivita,dat_zmena,zmenu_prov,zkratka,nazev,ob_jmeno,typ_esu,ixs_nad,stat,psc,obec,cast_obce,ulice,cor,cpop,ico,dic,tel,mail,typ_org) V2:(aktivita) K1:(f_ginsesu_typ_adr,f_ginsesu_typ_esu,f_ginsesu_typ_org) K2:(f_ginsesu_stat,lf_ginsesu_psc) K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdmInterniSubjektDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamAdmInterniSubjektDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_esu */
            public ixs_esu: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdmInterniSubjektListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdmInterniSubjektDesigner>, ixs_esu: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_esu);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdmInterniSubjektDesigner>, ixs_esu: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdmInterniSubjektDesigner>, ev, ctx): any {
            var filterObj = {
            }
            that.view = new Gordic.Isl.View(that.isl.AdmInterniSubjekt.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdmInterniSubjektDesignerInit
         * 
         * @param {GContentType<SeznamAdmInterniSubjektDesigner>} that
         */
        static SeznamAdmInterniSubjektDesignerInit(that: GContentType<SeznamAdmInterniSubjektDesigner>, ixs_esu: string ) {

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_esu);

            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);

            var filterObj: any = {}
            that.view = new Gordic.Isl.View(that.isl.AdmInterniSubjekt.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamAdmInterniSubjektDesignerInit

    }
}
